import { render } from "./UIUXIntroduction.vue?vue&type=template&id=3442b24d"
import script from "./UIUXIntroduction.vue?vue&type=script&lang=js"
export * from "./UIUXIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__